import {
  REQUEST_POSITIONS,
  RESPONSE_POSITIONS,
  REQUEST_POSITIONS_FAILURE,
  SET_POSITIONS_DATA,
  SET_POSITIONS_PAGE,
  CLEAR_POSITIONS,
  SET_CURRENT_POSITION_DATE,
  SET_POSITIONS_TABLE_DATA,
  SET_POSITIONS_TABLE_SCROLL,
} from "../actions/positionsActions";

import { states } from "./queriesStates";

const initialState = {
  dataState: states.NOT_REQUESTED,
  count: 0,
  information: {},
  data: [],
  tableData: {},
  page: [],
  errors: [],
  page: 1,
  currentDate: null,
  tablePageData: {},
  tableScroll: 0,
};

const positionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_POSITIONS:
      return Object.assign({}, state, {
        dataState: states.REQUEST,
      });
    case RESPONSE_POSITIONS:
      const { count, information, data, tableData } = action.payload;

      return Object.assign({}, state, {
        dataState: states.READY,
        count: count,
        information: information,
        tableData: tableData,
        data: data,
        page: 1,
        errors: {},
      });
    case REQUEST_POSITIONS_FAILURE:
      return Object.assign({}, state, {
        dataState: states.FAILURE,
        errors: action.errors,
      });
    case SET_POSITIONS_DATA:
      return Object.assign({}, state, {
        tableData: action.data,
      });
    case SET_POSITIONS_PAGE:
      return Object.assign({}, state, {
        page: action.data,
      });
    case SET_CURRENT_POSITION_DATE:
      return Object.assign({}, state, {
        currentDate: action.data,
      });
    case SET_POSITIONS_TABLE_DATA:
      return Object.assign({}, state, {
        tablePageData: action.data,
      });
    case CLEAR_POSITIONS:
      return Object.assign({}, state, initialState);
    case SET_POSITIONS_TABLE_SCROLL:
      return Object.assign({}, state, {
        tableScroll: action.data,
      });
    default:
      return state;
  }
};

export default positionsReducer;
